export const PILL_STYLES = {
  inner: 'border-red-600 text-red-700 bg-red-50',
  middle: 'border-blue-600 text-blue-700 bg-blue-50',
  outer: 'border-gray-500 text-gray-600 bg-gray-50',
  committed: 'border-green-600 text-green-700 bg-green-50',
  cultivation: 'border-amber-500 text-amber-700 bg-amber-50',
  outreach: 'border-blue-500 text-blue-700 bg-blue-50',
  research: 'border-gray-400 text-gray-600 bg-gray-50',
  drafting: 'border-amber-500 text-amber-700 bg-amber-50',
  awarded: 'border-green-600 text-green-700 bg-green-50',
  researching: 'border-gray-400 text-gray-600 bg-gray-50',
  rejected: 'border-red-400 text-red-600 bg-red-50',
  ceo: 'border-green-600 text-green-700 bg-green-50',
  board: 'border-red-600 text-red-700 bg-red-50',
  tier1: 'border-red-600 text-red-700 bg-red-50',
  signed: 'border-green-600 text-green-700 bg-green-50',
  in_discussion: 'border-amber-500 text-amber-700 bg-amber-50',
  target: 'border-gray-400 text-gray-600 bg-gray-50',
  active: 'border-green-600 text-green-700 bg-green-50',
  trial: 'border-amber-500 text-amber-700 bg-amber-50',
  churned: 'border-gray-400 text-gray-600 bg-gray-50',
  call: 'border-blue-500 text-blue-700 bg-blue-50',
  meeting: 'border-red-500 text-red-700 bg-red-50',
  email: 'border-gray-400 text-gray-600 bg-gray-50',
  overdue: 'border-red-600 text-red-700 bg-red-50',
  pending: 'border-amber-500 text-amber-700 bg-amber-50',
  done: 'border-green-600 text-green-700 bg-green-50',
  leadership: 'border-gray-400 text-gray-600 bg-gray-50',
  engineering: 'border-gray-400 text-gray-600 bg-gray-50',
  operations: 'border-gray-400 text-gray-600 bg-gray-50',
  security: 'border-gray-400 text-gray-600 bg-gray-50',
  grc: 'border-gray-400 text-gray-600 bg-gray-50',
  legal: 'border-gray-400 text-gray-600 bg-gray-50',
};

export function Pill({ value, label }) {
  const text = label || String(value || '').replace(/_/g, ' ');
  const cls = PILL_STYLES[value] || 'border-gray-400 text-gray-600 bg-gray-50';
  return <span className={`ldb-pill ldb-sans ${cls}`}>{text}</span>;
}

export function fmtUsd(n) {
  return `$${Number(n || 0).toLocaleString()}`;
}

export function progressPct(current, target) {
  if (!target) return 0;
  return Math.min(100, Math.round((current / target) * 100));
}

export function isOverdue(dateStr) {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}

export function downloadCsv(filename, headers, rows) {
  const escape = (v) => {
    const s = String(v ?? '');
    return s.includes(',') || s.includes('"') ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [headers.join(','), ...rows.map((r) => r.map(escape).join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
